import { Key, useCallback, useEffect, useMemo, useState } from 'react';
import { Link, Outlet, useNavigate, useParams } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';

import { useAuth } from 'context/AuthContext';

import ArticlePlaceholder from 'components/ui/article-placeholder';

import Box from 'components/ui/box';
import { getPlayerInfo, getServerTime, getTasks } from 'services/dashboard.service';
import { TaskItem } from 'components/task-item';

import ImgFeedback from 'assets/img/comportamento/bg-missoes-not-found.png';
import Button from 'components/ui/button';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { BsPlusLg } from 'react-icons/bs';
import { BiMinus } from 'react-icons/bi';
import CustomSelect from 'components/custom-select';
import Detail from './Detail';
import { subMinutes } from 'date-fns';
import { format } from 'date-fns-tz';
import { NotFound } from 'pages/NotFound';
import { TaskItemEcoa } from 'components/task-item-ecoa';
import { getNamedDates, GetVersion } from 'services/utils';
import { getFutureCalendarEcoa } from 'utils/helpers';

// const currentCycle = 1;

export default function Acao() {
  const { user, userInfo, realCycle, cycleSelected, setCycleSelected, cyclesExtended } = useAuth();
  const navigate = useNavigate();
  const params = useParams();
  

  const [realDatetime, setRealDatetime] = useState<number>(0);

  const [loading, setLoading] = useState(true);
  const [myTasks, setMyTasks] = useState<any[]>();
  const [otherTasks, setOtherTasks] = useState<any[]>();
  const [allTasks, setAllTasks] = useState<any[]>();

  const [taskCycles, setTaskCycles] = useState<any>();
  const [taskCyclesAll, setTaskCyclesAll] = useState<any>();

  const [tab, setTab] = useState<'cadastrada' | 'participando'>('cadastrada');
  const [cycleActive, setCycleActive] = useState<string>();
  const [showMore, setShowMore] = useState(false);
  const [numberOfElements, setNumberOfElements] = useState(3);
  const [optionsCycle, setOptionsCycle] = useState<any[] | undefined>([]);
  const [activeItem, setActiveItem] = useState<any>();
  const [showDetail, setShowDetail] = useState(false);

  const [calendarElementsIndexOf, setCalendarElementsIndexOf] = useState<number>(5);
  const [calendarNumberOfElements, setCalendarNumberOfElements] = useState(5);
  const [calendarShowMore, setCalendarShowMore] = useState(false);

  function handleClickCreate() {
    navigate('./cadastrar');
  }

  useEffect(() => {
    let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);

      interv = window.setInterval(() => {
        setRealDatetime(prevstate => prevstate + 1000);
      }, 1000);
    });

    return () => clearInterval(interv);
  }, []);

  const activeCycleObj = useMemo(() => {
    if (cycleActive === 'semestral') {
      const cycle = realCycle?.find(x => x._id === cycleSelected?._id);

      const evaluationStage = taskCycles.find((x: any) => x.status === 'open' || x.status === 'evaluation');
      if (!evaluationStage || !cycle?.date_start || !cycle?.date_end) return taskCycles?.[0];

      const _stages = {
        ...evaluationStage,
        title: 'Semestral',
        date_start: cycle?.date_start,
        date_finish: cycle?.date_end,
        step: 5,
        // taskStep >= 5 getTaskStep
      };

      return _stages;
    }

    return taskCycles?.find((item: any) => item._id === cycleActive);
  }, [cycleActive, cycleSelected?._id, realCycle, taskCycles]);

  const activeStageObj = useMemo(() => {
    if (!taskCycles) return null;
    const stag = taskCycles?.find((item: any) => item.status === 'open' || item.status === 'evaluation');
    if (stag) {
      return stag;
    }

    return taskCycles[0];
  }, [taskCycles]);

  const getFullCalendar = useMemo(() => {
    if (!cyclesExtended || !cycleSelected) return null;

    const cycleActive = cyclesExtended.find(x => x._id === cycleSelected?._id);

    if (cycleActive) {
      const calendar = getFutureCalendarEcoa(cycleActive?.steps, realDatetime);
      // console.table(calendar);
      return calendar;
    }

    return null;
  }, [cycleSelected, cyclesExtended, realDatetime]);

  const tasksPerCycle: any = useMemo(() => {
    if (!Array.isArray(myTasks) || !Array.isArray(otherTasks) || !taskCycles?.length || !cycleActive) return null;

    const tasks = [...(tab === 'cadastrada' ? myTasks : otherTasks)];

    return tasks?.length ? tasks : [];
  }, [cycleActive, myTasks, otherTasks, tab, taskCycles]);

  const resumePerCycle: {
    registered: number;
    validated: number;
    waiting: number;
  } | null = useMemo(() => {
    if (!Array.isArray(myTasks) || !Array.isArray(otherTasks) || !taskCycles?.length || !cycleActive) return null;

    const cycle = taskCycles.find((cycle: any) => cycle._id === cycleActive);
    const tasks = [...(tab === 'cadastrada' ? myTasks : otherTasks)]?.filter(
      item => item.created >= cycle?.date_start && item?.created <= cycle?.date_finish,
    );

    return {
      registered: tasks.length || 0,
      validated: tasks?.filter(task => !!task.status?.match(/(aprovado|dobrado|promovido|selo|concluido)/gi))?.length || 0,
      waiting: tasks?.filter(task => !!task.status?.match(/(aguardando)/gi))?.length || 0,
    };
  }, [cycleActive, myTasks, otherTasks, tab, taskCycles]);

  const getActiveEvaluationStep: 0 | 2 | 3 | 4 | 4.1 | 5 | null = useMemo((): 0 | 2 | 3 | 4 | 4.1 | 5 | null => {
    if (!activeCycleObj || activeCycleObj.status !== 'evaluation' || !realDatetime) return null;

    if (realDatetime > activeCycleObj.date_evaluation_step2_start && realDatetime < activeCycleObj.date_evaluation_step2_finish) {
      // Etapa 2
      return 2;
    } else if (
      realDatetime > activeCycleObj.date_evaluation_step3_start &&
      realDatetime < activeCycleObj.date_evaluation_step3_finish
    ) {
      // Etapa 3
      return 3;
    } else if (
      realDatetime > activeCycleObj.date_evaluation_step4_start &&
      realDatetime < activeCycleObj.date_evaluation_step4_finish
    ) {
      // Etapa 4
      return 4;
    } else if (
      realDatetime > activeCycleObj.date_evaluation_pitStop_start &&
      realDatetime < activeCycleObj.date_evaluation_pitStop_finish
    ) {
      // Pit Stop
      return 4.1;
    } else if (
      realDatetime > activeCycleObj.date_evaluation_step5_start &&
      realDatetime < activeCycleObj.date_evaluation_step5_finish
    ) {
      // Etapa 5
      return 5;
    } else {
      return 0;
    }
  }, [activeCycleObj, realDatetime]);

  const taskEditable = useCallback(
    (task: any): boolean => {
      if (!activeCycleObj || !user) return false;

      if (tab === 'cadastrada' && task.owner === user._id) {
        if (
          task.status === 'aguardando' &&
          activeCycleObj.status === 'open' &&
          task.created >= activeCycleObj?.date_start &&
          task.created <= activeCycleObj?.date_finish
        ) {
          return true;
        }

        if (
          task.status === 'rejeitado' &&
          getActiveEvaluationStep &&
          getActiveEvaluationStep === 2 &&
          task.created >= activeCycleObj?.date_start &&
          task.created <= activeCycleObj?.date_evaluation
        ) {
          return true;
        }

        return false;
      }

      return false;
    },
    [activeCycleObj, getActiveEvaluationStep, tab, user],
  );

  function renderTasksPerCycle() {
    if (!resumePerCycle) return null;

    try {
      if (tasksPerCycle?.length) {
        return tasksPerCycle.map((task: { _id: Key | null | undefined; owner: string | undefined; status: string }) => (
          <div key={task._id}>
            <TaskItemEcoa
              ecoa={true}
              data={task}
              editable={taskEditable(task)}
              onDelete={() => loadData()}
              onReload={() => loadData()}
              cycle={activeCycleObj}
              playerInfo={userInfo}
            />
          </div>
        ));
      }
    } catch (e) {
      return null;
    }
  }

  function renderCreateTaskPerCycle() {
    if (!resumePerCycle) return null;

    if (activeStageObj?._id === '68af4da8458e527eaa788503') return;

    // if(tab === 'cadastrada' && myTasks && myTasks?.length >= 1) return;

    // if (tab === 'cadastrada' && allTasks && allTasks?.length >= 1)
    //   return (
    //     <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
    //       <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
    //         <strong className="block text-center text-yellow font-semibold text-xl">
    //           {/* Você{activeCycleObj?.status === 'open' ? ' ainda' : ''} não foi incluído em Ações ECOA de outros */}
    //           Você já foi incluído em uma Ação ECOA nesta fase!
    //         </strong>

    //       </p>
    //     </div>
    //   );

    // if (tab === 'participando' && otherTasks && otherTasks?.length >= 1) return;

    return (
      <>
        {tab === 'cadastrada' && (
          <>
            {activeCycleObj?.status === 'open' && (
              <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
                <img src={ImgFeedback} className="max-w-[150px]" alt=" " />
                <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    {/* {activeCycleObj?.status === 'open' ? ' ainda não possui uma' : ' não possui'} Ação ECOA nesta fase */}
                    Que tal cadastrar uma Ação ECOA nesta fase?
                  </strong>
                  {/* {activeCycleObj?.status === 'open' ? (
              <>
                Cadastre sua Ação ECOA, seja reconhecido pela liderança e ganhe recompensas! <br />
                Lembre-se: você só pode cadastrar uma ação por mês (fase). <br />
                <b>Atenção</b>: só devem ser cadastradas Ações <b>concluídas</b>.
              </>
            ) : null} */}
                </p>
                {activeCycleObj?.status === 'open' &&
                tab === 'cadastrada' &&
                !userInfo?.visualizador &&
                !!userInfo?.ecoa &&
                userInfo?.ecoa === 'INTEGRANTE' ? (
                  <button
                    className="text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded py-3 px-10"
                    onClick={() => handleClickCreate()}
                  >
                    Cadastrar Ação ECOA
                  </button>
                ) : null}
              </div>
            )}

            {activeCycleObj?.status !== 'open' && (!myTasks || !myTasks?.length || myTasks?.length === 0) && (
              <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
                <img src={ImgFeedback} className="max-w-[150px]" alt=" " />
                <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    {/* {activeCycleObj?.status === 'open' ? ' ainda não possui uma' : ' não possui'} Ação ECOA nesta fase */}
                    Você não cadastrou nenhuma Ação ECOA nesta fase
                  </strong>
                  {/* {activeCycleObj?.status === 'open' ? (
              <>
                Cadastre sua Ação ECOA, seja reconhecido pela liderança e ganhe recompensas! <br />
                Lembre-se: você só pode cadastrar uma ação por mês (fase). <br />
                <b>Atenção</b>: só devem ser cadastradas Ações <b>concluídas</b>.
              </>
            ) : null} */}
                </p>
                {activeCycleObj?.status === 'open' &&
                tab === 'cadastrada' &&
                !userInfo?.visualizador &&
                !!userInfo?.ecoa &&
                userInfo?.ecoa === 'INTEGRANTE' ? (
                  <button
                    className="text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded py-3 px-10"
                    onClick={() => handleClickCreate()}
                  >
                    Cadastrar Ação ECOA
                  </button>
                ) : null}
              </div>
            )}
          </>
        )}
        {tab === 'participando' && (!otherTasks || !otherTasks?.length || otherTasks?.length === 0) && (
          <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
            <img src={ImgFeedback} className="max-w-[150px]" alt=" " />
            <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
              <strong className="block text-center text-yellow font-semibold text-xl">
                {/* Você{activeCycleObj?.status === 'open' ? ' ainda' : ''} não foi incluído em Ações ECOA de outros */}
                Você ainda não foi incluído em Ações ECOA
              </strong>
              {/* {activeCycleObj?.status === 'open'
              ? 'Caso tenha colaborado em alguma ação de outra equipe, verifique com seus colegas a possibilidade de ser indicado.'
              : ''} */}
            </p>
          </div>
        )}
      </>
    );
  }

  useEffect(() => {
    if (taskCycles?.length) {
      const currentCycle = taskCycles?.find((item: any) => item.status === 'open');
      setCycleActive(currentCycle?._id || taskCycles[0]._id);
    }
  }, [tab, taskCycles]);

  // useEffect(() => {
  //   console.log('tasksPerCycle', tasksPerCycle);
  //   console.log('resumePerCycle', resumePerCycle);
  // }, [tasksPerCycle, resumePerCycle]);

  async function loadData() {
    if (!realCycle?.[0]) return;

    if (!!userInfo?.ecoa && userInfo.ecoa !== 'INTEGRANTE') {
      setTab('participando');
    }

    const data = await getTasks(user?._id, activeCycleObj?.date_start, activeCycleObj?.date_finish, true);

    const my_tasks = data.filter((item: any) => item.owner === user?._id && item.status !== 'arquivado');
    const other_tasks = data.filter((item: any) => item.owner !== user?._id && item.status !== 'arquivado');

    setMyTasks(my_tasks);
    setOtherTasks(other_tasks);
    setAllTasks([...my_tasks, ...other_tasks]);

    setLoading(false);
  }

  useEffect(() => {
    if (!realCycle) return;

    const cycleOptions = realCycle
      .filter(item => item.date_start >= getNamedDates().ciclo_2S2024)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    setOptionsCycle(cycleOptions);

    if (!activeItem) {
      setActiveItem(cycleOptions.find(x => x.value === cycleSelected?._id) ? cycleSelected?._id : cycleOptions[0].value);
      setTaskCyclesAll(realCycle.filter((item: any) => item.year > 2022));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle]);

  useEffect(() => {
    if (!user || !realCycle || !taskCycles || !activeCycleObj) return;

    setLoading(true);

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, realCycle, taskCycles, activeCycleObj]);

  useEffect(() => {
    if (!taskCycles) return;

    if (taskCycles.length <= numberOfElements) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  }, [numberOfElements, taskCycles]);

  useEffect(() => {
    if (!activeItem) return;

    const filtredData = taskCyclesAll?.filter((item: any) => item._id === activeItem);

    if (!!filtredData?.length) {
      setTaskCycles(filtredData[0].steps);
    }
  }, [activeItem, taskCyclesAll]);

  useEffect(() => {
    if (!getFullCalendar) return;

    if (getFullCalendar.length <= calendarNumberOfElements) {
      setCalendarShowMore(false);
    } else {
      setCalendarShowMore(true);
    }
  }, [calendarNumberOfElements, getFullCalendar]);

  function getIndexByValue(array: any, value: string) {
    return array.findIndex((element: any) => element.value === value);
  }

  useEffect(() => {
    if (params?.id) return;

    if (cycleSelected) {
      if (cycleSelected?.version && cycleSelected?.version) {
        navigate(`/${cycleSelected.version}/acao-ecoa`);
      } else {
        navigate(`/acao-ecoa`);
      }
    }
  }, [cycleSelected, navigate]);

  if (!user || !userInfo) return null;

  // if (isGestor && !loading) {
  //   return (
  //     <div className="mx-auto container p-4 lg:p-10">
  //       <div className="flex flex-row items-center space-x-4 mb-16">
  //         <div>
  //           <Link to="../">
  //             <button className="rounded-full bg-purple flex justify-center items-center p-1">
  //               <RiArrowLeftSLine size={28} className="text-white" />
  //             </button>
  //           </Link>
  //         </div>
  //         <h1 className="text-xl lg:text-3xl text-white font-semibold">Ação ECOA</h1>
  //       </div>

  //       <div className="border-2 border-electric-blue rounded-3xl p-8 bg-oxford-blue">
  //         <p className="text-dandelion text-lg font-semibold block text-center">Você não possui acesso à esta página.</p>
  //       </div>
  //     </div>
  //   );
  // }

  if (showDetail) return <Detail onClose={() => setShowDetail(false)} />;

  if (user.extra.rede || !userInfo.ecoa || userInfo.ecoa === 'TUTOR') return <NotFound />;

  return (
    <>
      <div className="mx-auto container p-4 lg:p-10">
        <div className="flex flex-row items-center space-x-4 mb-16">
          <Link
            to="../"
            className="rounded-full bg-purple flex justify-center items-center p-1 no-underline hover:opacity-80"
            aria-label="Voltar para página anterior"
          >
            <RiArrowLeftSLine size={28} className="text-white" aria-hidden="true" />
          </Link>
          <h1 className="text-xl lg:text-3xl text-white font-semibold">Ações ECOA</h1>
        </div>

        <div className="border-2 border-electric-blue rounded-3xl p-8 mb-12 bg-oxford-blue">
          <p className="text-dandelion text-lg font-semibold block mb-3">Como funciona a dinâmica Ação ECOA?</p>
          <p className="text-white text-base font-light m-0">
            É uma ação contínua de engajamento para reconhecer e dar visibilidade às ações realizadas pelas Ecoas.
            <br />
            Os integrantes da Ecoa cadastram as ações e coordenador ou tutor pode dar ciência, validar e bonificar.
            {/* <br />
            Cadastre e descreva detalhadamente sua ação mais relevante do mês. Ela será apreciada pelos seus líderes e todos os
            participantes poderão receber pontos,
            <em className="italic">feedbacks</em> e <strong className="font-semibold">Selo Ação ECOA</strong>. */}
          </p>
        </div>

        <div className="rounded-xl overflow-hidden hidden lg:flex items-center justify-between mb-12" role="group" aria-label="Navegação entre abas">
          {userInfo.ecoa === 'INTEGRANTE' && (
            <button
              className={`${
                tab === 'cadastrada' ? 'bg-slate-blue' : 'bg-maastricht-blue'
              } w-6/12 h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-opacity`}
              onClick={() => (!loading ? setTab('cadastrada') : null)}
              aria-pressed={tab === 'cadastrada'}
            >
              Ação ECOA cadastrada
            </button>
          )}
          <button
            className={`${tab === 'participando' ? 'bg-slate-blue' : 'bg-maastricht-blue'} ${
              userInfo.ecoa !== 'INTEGRANTE' ? 'w-full' : 'w-6/12'
            }  h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-opacity`}
            onClick={() => (!loading ? setTab('participando') : null)}
            aria-pressed={tab === 'participando'}
          >
            Participação em Ações ECOA
          </button>
        </div>

        <nav className="flex justify-between items-center lg:hidden mb-10" aria-label="Navegação entre abas">
          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={tab === 'cadastrada'}
            onClick={() => setTab('cadastrada')}
            aria-label="Ação ECOA cadastrada"
          >
            <IoIosArrowBack className={`text-grey-dark ${tab === 'cadastrada' && 'opacity-5'}}`} size={24} aria-hidden="true" />
          </Button>

          <p className="text-xl font-bold text-yellow" role="status" aria-live="polite">
            {tab === 'cadastrada' ? 'Ação ECOA cadastrada' : 'Participação em Ações ECOA'}
          </p>

          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={tab === 'participando'}
            onClick={() => setTab('participando')}
            aria-label="Participação em Ações ECOA"
          >
            <IoIosArrowForward className={`text-grey-dark ${tab === 'participando' && 'opacity-5'}}`} size={24} aria-hidden="true" />
          </Button>
        </nav>

        <div className="w-full flex flex-col lg:flex-row lg:justify-between">
          <div className="lg:w-[32.5%]">
            <div className="mb-5">
              <h2 className="text-xl text-white block mb-6 font-semibold">Histórico de Ações ECOA</h2>

              <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 mb-8">
                      <div>
                        <p className="mb-2" id="cycle-label-ecoa">
                          Escolha o ciclo que deseja acompanhar
                        </p>

                        {optionsCycle && (
                          <div className="mb-4">
                            <CustomSelect
                              placeholder="Clique para selecionar o ciclo"
                              options={optionsCycle}
                              onChange={(e: any) => {
                                setActiveItem(e.value);

                                const selected = realCycle?.find(x => x._id === e.value);

                                if (selected) {
                                  setCycleSelected({
                                    _id: selected._id,
                                    title: selected.title,
                                    version: GetVersion(selected?.date_start),
                                  });
                                }
                              }}
                              value={
                                optionsCycle.find(x => x.value === cycleSelected?._id)
                                  ? optionsCycle.find(x => x.value === cycleSelected?._id)
                                  : optionsCycle[getIndexByValue(optionsCycle, activeItem)]
                              }
                            />
                          </div>
                        )}
                      </div>

                      <p className="text-white mb-8 text-base font-normal block" id="phase-label-ecoa">
                        Escolha a fase
                      </p>

                      <ul className="space-y-4 flex flex-col" aria-labelledby="phase-label-ecoa">
                        {activeStageObj?.semester_title &&
                          activeStageObj?.date_evaluation_step5_start &&
                          activeStageObj?.date_evaluation_step5_finish && (
                            <li>
                              <button
                                className={`${
                                  cycleActive === 'semestral' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                                onClick={() => {
                                  setCycleActive('semestral');
                                }}
                                aria-current={cycleActive === 'semestral' ? 'true' : undefined}
                              >
                                {activeStageObj?.semester_title}
                              </button>
                            </li>
                          )}

                        {taskCycles &&
                          taskCycles.slice(0, numberOfElements).map((cycle: any) => (
                            <li key={cycle._id}>
                              <button
                                className={`${
                                  cycleActive === cycle._id ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                                onClick={() => setCycleActive(cycle._id)}
                                aria-current={cycleActive === cycle._id ? 'true' : undefined}
                              >
                                {cycle.title}
                                {/* {GetTaskStatusLabel(cycle.status)} */}
                              </button>
                            </li>
                          ))}

                        {taskCycles.length > 3 && (
                          <button
                            className="mt-4 mx-auto flex items-center text-grey-light justify-center lg:justify-start"
                            onClick={() => (!showMore ? setNumberOfElements(3) : setNumberOfElements(numberOfElements + 3))}
                            aria-expanded={!showMore}
                            aria-label={!showMore ? "Ver menos fases" : "Ver mais fases"}
                          >
                            {!showMore ? (
                              <>
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} aria-hidden="true" />
                                <span className="uppercase">Ver menos</span>
                              </>
                            ) : (
                              <>
                                <BsPlusLg className="mr-2 inline-block grey-dark" size={17} aria-hidden="true" />
                                <span className="uppercase">Ver mais</span>
                              </>
                            )}
                          </button>
                        )}
                      </ul>
                    </div>

                    <section className="bg-maastricht-blue rounded-3xl p-8" aria-labelledby="resume-ecoa-heading">
                      <h3 id="resume-ecoa-heading" className="block text-white leading-none font-normal text-base mb-4">
                        Ações ECOA de {activeCycleObj?.title}
                      </h3>

                      <ul className="flex flex-col w-full">
                        <li className="flex items-center justify-between text-white font-light text-xs leading-none mb-4 pb-4 border-b border-prussian-blue-2">
                          {tab === 'cadastrada' ? 'Total de Ações cadastradas' : 'Total de Ações cadastradas que você participa'}{' '}
                          <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2" aria-label={`${resumePerCycle?.registered || '0'} ações cadastradas`}>
                            {resumePerCycle?.registered || '0'}
                          </span>
                        </li>
                        <li className="flex items-center justify-between text-white font-light text-xs leading-none mb-4 pb-4 border-b border-prussian-blue-2">
                          {tab === 'cadastrada' ? 'Total de Ações validadas' : 'Total de Ações validadas que você participa'}{' '}
                          <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2" aria-label={`${resumePerCycle?.validated || '0'} ações validadas`}>
                            {resumePerCycle?.validated || '0'}
                          </span>
                        </li>
                        <li className="flex items-center justify-between text-white font-light text-xs leading-none">
                          {tab === 'cadastrada'
                            ? 'Total de Ações aguardando validação'
                            : 'Total de Ações aguardando validação que você participa'}{' '}
                          <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2" aria-label={`${resumePerCycle?.waiting || '0'} ações aguardando validação`}>
                            {resumePerCycle?.waiting || '0'}
                          </span>
                        </li>
                      </ul>
                    </section>
                  </>
                )}
              </Box>
            </div>

            {/* <div className="pt-3">
              <h2 className="text-xl text-white block mb-6 font-semibold">Calendário de validação/apreciação</h2>

              <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    {!!activeCycleObj && (
                      <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                        <p className="block text-white leading-none font-normal text-base pb-2">Fase {activeCycleObj?.title}</p>

                        <div className="font-thin">
                          {activeCycleObj?.date_evaluation_step2_start && activeCycleObj?.date_evaluation_step2_finish && (
                            <p>
                              <span className="text-yellow font-light">
                                {format(activeCycleObj?.date_evaluation_step2_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeCycleObj?.date_evaluation_step2_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              Validação (Líderes imediatos)
                            </p>
                          )}

                          {activeCycleObj?.date_evaluation_step3_start && activeCycleObj?.date_evaluation_step3_finish && (
                            <p className="pt-4 border-t border-prussian-blue-2">
                              <span className="text-yellow font-light">
                                {format(activeCycleObj?.date_evaluation_step3_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeCycleObj?.date_evaluation_step3_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              Apreciação Nível 1
                            </p>
                          )}

                          {activeCycleObj?.date_evaluation_step4_start && activeCycleObj?.date_evaluation_step4_finish && (
                            <p className="pt-4 border-t border-prussian-blue-2">
                              <span className="text-yellow font-light">
                                {format(activeCycleObj?.date_evaluation_step4_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeCycleObj?.date_evaluation_step4_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              Apreciação Nível 2
                            </p>
                          )}
                          {activeCycleObj?.date_evaluation_pitStop_start && activeCycleObj?.date_evaluation_pitStop_finish && (
                            <p className="pt-4 border-t border-prussian-blue-2">
                              <span className="text-yellow font-light">
                                {format(activeCycleObj?.date_evaluation_pitStop_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeCycleObj?.date_evaluation_pitStop_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              PIT STOP - Realizações da Rede
                            </p>
                          )}
                          {activeCycleObj?.date_evaluation_step5_start && activeCycleObj?.date_evaluation_step5_finish && (
                            <p className="pt-4 border-t border-prussian-blue-2">
                              <span className="text-yellow font-light">
                                {format(activeCycleObj?.date_evaluation_step5_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeCycleObj?.date_evaluation_step5_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              Apreciação Nível 3 (Gerentes Gerais UE e Diretores)
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </Box>
            </div> */}

            {!!getFullCalendar && getFullCalendar?.length > 0 && activeStageObj?._id !== '68af4da8458e527eaa788503' && (
              <div className="pt-3">
                <h2 className="text-xl text-white block mb-6 font-semibold">Calendário</h2>

                <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                  {loading ? (
                    <div className="grid grid-cols-1 gap-3">
                      <ArticlePlaceholder />
                    </div>
                  ) : (
                    <>
                      <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                        <div className="font-thin">
                          {getFullCalendar.slice(0, calendarNumberOfElements).map((item, idx) => (
                            <p className={idx === 0 ? 'm-0' : `pt-2 mt-2 border-t border-prussian-blue-2`} key={item.title}>
                              <span className="text-yellow font-light">
                                {format(item.start, 'dd/MM')} a {format(subMinutes(item.end, 10), 'dd/MM')}:
                              </span>{' '}
                              {item.stage} - <span className="text-blue-light font-light">{item.period}</span>
                            </p>
                          ))}

                          {!!getFullCalendar && getFullCalendar?.length > (calendarElementsIndexOf as number) && (
                            <button
                              className="mt-4 mx-auto flex items-center text-grey-light justify-center lg:justify-start"
                              onClick={() =>
                                !calendarShowMore
                                  ? setCalendarNumberOfElements(calendarElementsIndexOf as number)
                                  : setCalendarNumberOfElements(calendarNumberOfElements + 5)
                              }
                              aria-expanded={!calendarShowMore}
                              aria-label={!calendarShowMore ? "Ver menos datas do calendário" : "Ver mais datas do calendário"}
                            >
                              {!calendarShowMore ? (
                                <>
                                  <BiMinus className="mr-2 inline-block grey-dark" size={17} aria-hidden="true" />
                                  <span className="uppercase">Ver menos</span>
                                </>
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} aria-hidden="true" />
                                  <span className="uppercase">Ver mais</span>
                                </>
                              )}
                            </button>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </Box>
              </div>
            )}

            {/* <div className="pt-3">
              <h2 className="text-xl text-white block mb-6 font-semibold">Ações da sua unidade</h2>

              <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 flex flex-col items-center">
                      <p className="mb-5">Deseja acompanhar as Ações ECOA cadastradas pelos colegas da sua unidade?</p>

                      <button
                        className={`text-white text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                        onClick={() => setShowDetail(true)}
                      >
                        ver Ações
                      </button>
                    </div>
                  </>
                )}
              </Box>
            </div> */}
          </div>

          <div className="lg:w-[64.8%]">
            <h2 className="text-xl text-white block mb-6 font-semibold">Ações ECOA {activeCycleObj?.title}</h2>

            <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px] space-y-6">
              {loading ? (
                <div className="grid grid-cols-1 gap-3">
                  <ArticlePlaceholder />
                </div>
              ) : (
                <>
                  {renderCreateTaskPerCycle()}
                  {renderTasksPerCycle()}
                </>
              )}
            </Box>
          </div>
        </div>
      </div>

      <Outlet />
    </>
  );
}
